module.exports = __webpack_public_path__ + "img/ig.e59adba7.png";